module.exports = __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.3e2c1c7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fonts/materialdesignicons-webfont.eot
// module id = tgfW
// module chunks = 1